var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutgoingCallSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0008 3.05375L2.08155 13.973C1.94305 14.1115 1.76905 14.1823 1.55955 14.1855C1.34988 14.1887 1.17263 14.1178 1.0278 13.973C0.882964 13.8282 0.810547 13.6526 0.810547 13.4462C0.810547 13.2397 0.882964 13.0641 1.0278 12.9192L11.947 2H5.7508C5.5383 2 5.36013 1.92808 5.2163 1.78425C5.07263 1.64042 5.0008 1.46225 5.0008 1.24975C5.0008 1.03708 5.07263 0.859 5.2163 0.7155C5.36013 0.571833 5.5383 0.5 5.7508 0.5H13.5968C13.853 0.5 14.0676 0.586667 14.2408 0.760001C14.4141 0.933167 14.5008 1.14783 14.5008 1.404V9.25C14.5008 9.4625 14.4289 9.64067 14.285 9.7845C14.1412 9.92817 13.963 10 13.7505 10C13.5379 10 13.3598 9.92817 13.2163 9.7845C13.0726 9.64067 13.0008 9.4625 13.0008 9.25V3.05375Z",
    fill: "#09C26F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutgoingCallSuccess);
export default __webpack_public_path__ + "static/media/outgoingCallSuccess.1922007689fa8ce796a44720fc4f5f13.svg";
export { ForwardRef as ReactComponent };